import SidePanel from './SidePanel';

import './index.scss';

export default SidePanel;
